module.exports = __webpack_public_path__ + "img/762e52a.svg";